module.exports = __webpack_public_path__ + "img/Meng_Wang@2x.7c052673.png";